import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section py-3 bg-light">
      <div className="container relative">
        <div className="row g-4">
          {/* About/Logo */}
          <div className="col-lg-6">
            <div className="mb-2 footer-logo-wrap">
              <a href="#" className="footer-logo h4 text-decoration-none text-dark">
                <img src="images/su_LOGO.jpg" class="navbar" alt='logo' style={{height: "65px", width: "200px"}} />
              </a>
            </div>
            <p>
              If you’re looking for the best sleep of your life, you have come to the right place! Your search for the best mattress in India ends at SpringUp Mattress.
            </p>
          </div>

          {/* Useful Links */}
          <div className="col-lg-2">
            <h5 className="mb-3 fw-bold" style={{ color: '#043b72' }}>Useful Links</h5>
            <ul className="list-unstyled">
              {/* <li><Link to="/profile" className="footer-link">User Account</Link></li> */}
              <li><Link to="/New_arrivals" className="footer-link">New Arrivals</Link></li>
              {/* <li><Link to="/shopping" className="footer-link">Mattress by Price</Link></li>
              <li><Link to="#" className="footer-link">Return Policy</Link></li> */}
              <li><Link to="/privacy_policy" className="footer-link">Warranty Terms</Link></li>
            </ul>
          </div>

          {/* Policies */}
          {/* <div className="col-lg-2">
            <h5 className="mb-3 fw-bold">Policies</h5>
            <ul className="list-unstyled">
              <li><Link to="/term_&_condition" className="footer-link">Terms & Conditions</Link></li>
              <li><Link to="/refund_cancellation" className="footer-link">Refund/Cancellation</Link></li>
              <li><Link to="/shipping_policy" className="footer-link">Shipping Policy</Link></li>
              <li><Link to="/privacy_policy" className="footer-link">Privacy Policy</Link></li>
            </ul>
          </div> */}

          {/* Follow Us */}
          <div className="col-lg-2">
            <h5 className="mb-3 fw-bold" style={{ color: '#043b72' }}>Follow Us</h5>
            <ul className="list-unstyled custom-social d-flex gap-2">
              <li>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-top pt-3 mt-5">
          <div className="row">
            <div className="col-lg-8 text-center text-lg-start">
              <p className="fw-bold mb-0">
                &copy; {currentYear} All Rights Reserved. — Designed by{' '}
                <a
                  href="https://servusys.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-underline text-dark"
                >
                  Servusys.
                </a>
              </p>
            </div>
            <div className="col-lg-4 text-center text-lg-end">
              <p className="fw-bold mb-0">Total Visitors: 999+</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;